import React, { useContext, useEffect, useRef, useState } from "react";
import { formatCoordinates } from "common/utils/coordinates";
import {
  ObjectInfoContainer,
  ObjectInfoRow,
} from "../AddressPanel/Header/__styles__/Header";
import { CoordinatesContainer } from "../AddressPanel/Header/__styles__/Header";
import { ActionButton } from "../Common/Buttons/ActionButton";
import { Body, Title } from "../Common/Typography";
import { LayerContext } from "../Maps/layers";
import { HeaderContainer } from "./__styles__/Header";

type ObjectInfoHeaderProps = {
  loading: boolean;
  objectType: string;
  objectName: string;
  onClose: () => void;
};

const LOADING_TEXT = "Loading...";

const Header = ({
  loading,
  objectType,
  objectName,
  onClose,
}: ObjectInfoHeaderProps) => {
  const { markerPoint } = useContext(LayerContext);
  const longitude = markerPoint?.longitude ?? null;
  const latitude = markerPoint?.latitude ?? null;
  const displayCoordinates = longitude && latitude;

  const objectInfoRef = useRef<HTMLDivElement>(null);
  const coordinatesRef = useRef<HTMLDivElement>(null);
  const [coordinatesWrapped, setCoordinatesWrapped] = useState(false);

  useEffect(() => {
    const checkWrap = () => {
      if (objectInfoRef.current && coordinatesRef.current) {
        setCoordinatesWrapped(
          objectInfoRef.current.offsetTop !== coordinatesRef.current.offsetTop,
        );
      }
    };

    checkWrap();
    window.addEventListener("resize", checkWrap);
    return () => window.removeEventListener("resize", checkWrap);
  }, [coordinatesRef.current, objectInfoRef.current]);

  return (
    <HeaderContainer data-panel-header>
      {loading ?
        <div>
          <em>{LOADING_TEXT}.</em>
        </div>
      : <>
          <ObjectInfoRow>
            <ObjectInfoContainer ref={objectInfoRef}>
              <Body
                size="small"
                type="regular"
                color="contentSecondaryInverted"
              >
                {objectType}
              </Body>
              <CoordinatesContainer ref={coordinatesRef} displayCoordinates>
                {displayCoordinates && (
                  <Body
                    size="small"
                    type="regular"
                    color="contentSecondaryInverted"
                  >
                    {!coordinatesWrapped && `• `}
                    {`Coordinates: ${formatCoordinates({
                      latitude,
                      longitude,
                    })}`}
                  </Body>
                )}
              </CoordinatesContainer>
            </ObjectInfoContainer>
            <ActionButton
              icon="x"
              onClick={onClose}
              aria-label="Close Object Information Panel"
              data-panel-close
              variant="inverted"
            />
          </ObjectInfoRow>
          <Title size="default" type="semiBold" color="contentPrimaryInverted">
            {objectName}
          </Title>
        </>
      }
    </HeaderContainer>
  );
};

export default Header;
